document.addEventListener('DOMContentLoaded', function() {
    /**
     * PLP Badge Update Script v4
     *
     * Handles dynamic badge updates on collection cards when hovering/clicking swatches.
     *
     * data-color-badge values set by card-color-swatch.liquid:
     *   'sold-out'   → show sold-out badge  (.sold-out-badge.badge)
     *   'Preorder'   → skip — theme renders preorder badge independently
     *   '5 LEFT' etc → show low-stock badge (.custom-badge.badge)
     *   'BEST SELLER'→ show custom badge    (.custom-badge.badge)
     *   '-20%' etc   → show sale badge      (.sale-badge.badge)
     *   'New'        → show new badge       (.custom-badge.badge)
     *   ''           → no badge — hide all visible badges
     *
     * Badge priority (set in Liquid, reflected in data-color-badge):
     *   preorder > sold-out > X LEFT > custom tag > -XX% sale > new > ''
     */

    var PREORDER_BADGES = ['preorder', 'pre-order'];

    function isPreorderBadge(text) {
      var lower = (text || '').trim().toLowerCase();
      for (var i = 0; i < PREORDER_BADGES.length; i++) {
        if (lower === PREORDER_BADGES[i]) return true;
      }
      return false;
    }

    // Detect if a badge text is a percent-off sale value e.g. "-20%"
    function isSaleBadge(text) {
      return /^-\d+%$/.test((text || '').trim());
    }

    /**
     * Update the badge in the card's image wrapper based on the swatch's
     * data-color-badge value.
     */
    function setBadge(card, badgeText) {
      var wrapper = card.querySelector('.grid-view-item-image');
      if (!wrapper) return;

      var badgeTrimmed = (badgeText || '').trim();

      // Skip preorder badges — the theme renders these independently
      if (isPreorderBadge(badgeTrimmed)) return;

      if (badgeTrimmed === 'sold-out') {
        showSoldOutBadge(wrapper);
      } else if (isSaleBadge(badgeTrimmed)) {
        // Use the red sale-badge element, update its percent text
        showSaleBadge(wrapper, badgeTrimmed);
      } else if (badgeTrimmed) {
        // Show text badge (low-stock "X LEFT", custom tag, "New")
        showTextBadge(wrapper, badgeTrimmed);
      } else {
        // No badge for this colour — hide all visible badges
        hideAllBadges(wrapper);
      }
    }

    function showSoldOutBadge(wrapper) {
      hideBadgeType(wrapper, '.custom-badge.badge');
      hideBadgeType(wrapper, '.sale-badge.badge');

      var soldOutBadge = wrapper.querySelector('.sold-out-badge.badge');
      if (soldOutBadge) {
        soldOutBadge.style.display = '';
      } else {
        var nb = document.createElement('div');
        nb.className = 'sold-out-badge badge';
        nb.setAttribute('data-injected-badge', 'true');
        nb.textContent = 'Sold out';
        wrapper.insertBefore(nb, wrapper.firstChild);
      }
    }

    function showSaleBadge(wrapper, text) {
      hideBadgeType(wrapper, '.custom-badge.badge');
      hideBadgeType(wrapper, '.sold-out-badge.badge');

      var saleBadge = wrapper.querySelector('.sale-badge.badge');
      if (saleBadge) {
        saleBadge.textContent = text;
        saleBadge.style.display = '';
      } else {
        // Create a sale badge if Liquid didn't render one (e.g. non-sale card
        // being hovered to a sale swatch on a combined listing)
        var nb = document.createElement('div');
        nb.className = 'sale-badge badge';
        nb.setAttribute('data-injected-badge', 'true');
        nb.textContent = text;
        wrapper.insertBefore(nb, wrapper.firstChild);
      }
    }

    function showTextBadge(wrapper, text) {
      hideBadgeType(wrapper, '.sold-out-badge.badge');
      hideBadgeType(wrapper, '.sale-badge.badge');

      var badge = wrapper.querySelector('.custom-badge.badge');
      if (badge) {
        badge.textContent = text;
        badge.style.display = '';
      } else {
        var nb = document.createElement('div');
        nb.className = 'custom-badge badge';
        nb.setAttribute('data-injected-badge', 'true');
        nb.textContent = text;
        wrapper.insertBefore(nb, wrapper.firstChild);
      }
    }

    function hideAllBadges(wrapper) {
      hideBadgeType(wrapper, '.custom-badge.badge');
      hideBadgeType(wrapper, '.sold-out-badge.badge');
      hideBadgeType(wrapper, '.sale-badge.badge');
    }

    function hideBadgeType(wrapper, selector) {
      var el = wrapper.querySelector(selector);
      if (el) el.style.display = 'none';
    }

    function getActiveSwatch(card) {
      return card.querySelector('.card-color-swatch--inner.active') ||
             card.querySelector('.card-color-swatch--inner');
    }

    function restoreBadge(card) {
      var active = getActiveSwatch(card);
      if (!active) return;
      var txt = (active.dataset.colorBadge || '').trim();
      setBadge(card, txt);
    }

    function attachListeners(card) {
      if (card.getAttribute('data-badge-listeners-attached')) return;
      card.setAttribute('data-badge-listeners-attached', 'true');

      var swatches = card.querySelectorAll('.card-color-swatch--inner');
      if (!swatches.length) return;

      swatches.forEach(function(swatch) {
        // Mouseover: preview badge for this colour
        swatch.addEventListener('mouseover', function() {
          var txt = (this.dataset.colorBadge || '').trim();
          setBadge(card, txt);
        });

        // Mouseleave on swatch: restore badge immediately when leaving the swatch
        swatch.addEventListener('mouseleave', function() {
          restoreBadge(card);
        });

        // Click: lock badge to this colour (theme JS will update active class)
        swatch.addEventListener('click', function() {
          var txt = (this.dataset.colorBadge || '').trim();
          setBadge(card, txt);
        });
      });

      // Also restore on card mouseleave as a safety net
      card.addEventListener('mouseleave', function() {
        restoreBadge(card);
      });
    }

    // Attach listeners to all cards present on page load
    document.querySelectorAll('product-card').forEach(attachListeners);

    // Handle dynamically loaded cards (infinite scroll, filtered results, etc.)
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          if (node.tagName && node.tagName.toLowerCase() === 'product-card') {
            attachListeners(node);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll('product-card').forEach(attachListeners);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
